const activeConversation = (state = {}, action) => {
    switch(action.type) {
        case 'SET_ACTIVE_CONVERSATION':
            return Object.assign({}, state, {[action.advert]: action.conversation});
        default:
            return state;
    }
};

export default activeConversation;


// WEBPACK FOOTER //
// ./src/reducers/activeConversation.js